import { Component } from '@angular/core';
import { IzzyIzzyActionOrganizationEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Izzy Action Organizations') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyizzyactionorganization-form',
    templateUrl: './izzyizzyactionorganization.form.component.html'
})
export class IzzyIzzyActionOrganizationFormComponent extends BaseFormComponent {
    public record!: IzzyIzzyActionOrganizationEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'actionOrganization', sectionName: 'Action & Organization', isExpanded: true },
            { sectionKey: 'grantDetails', sectionName: 'Grant Details', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

